import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { MANUAL_PAYMENT_LABELS } from "./CashbookTable";

export const EditPaymentDialog = ({ open, onOpenChange, editForm, setEditForm, onSave, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>Modifier l'entrée</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Nom</Label>
            <Input value={editForm.payer_last_name || ""} onChange={(e) => setEditForm({ ...editForm, payer_last_name: e.target.value })} />
          </div>
          <div className="space-y-2">
            <Label>Prénom</Label>
            <Input value={editForm.payer_first_name || ""} onChange={(e) => setEditForm({ ...editForm, payer_first_name: e.target.value })} />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Montant (€)</Label>
          <Input type="number" step="0.01" value={editForm.amount || ""} onChange={(e) => setEditForm({ ...editForm, amount: parseFloat(e.target.value) })} />
        </div>
        <div className="space-y-2">
          <Label>Nature / Sujet</Label>
          <Textarea value={editForm.nature || ""} onChange={(e) => setEditForm({ ...editForm, nature: e.target.value })} />
        </div>
        <div className="space-y-2">
          <Label>Mode de paiement</Label>
          <Select value={editForm.payment_type || ""} onValueChange={(v) => setEditForm({ ...editForm, payment_type: v })}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent className="z-[200]">
              {Object.entries(MANUAL_PAYMENT_LABELS).map(([key, label]) => (
                <SelectItem key={key} value={key}>{label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
        <Button onClick={onSave} disabled={loading}>{loading ? "Enregistrement..." : "Enregistrer"}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const DeletePaymentDialog = ({ open, onOpenChange, payment, onConfirm, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[400px]">
      <DialogHeader>
        <DialogTitle className="text-red-600">Supprimer l'entrée</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        <p className="text-[#577083]">Êtes-vous sûr de vouloir supprimer cette entrée ?</p>
        {payment && (
          <div className="mt-4 p-3 bg-[#f4f7fa] rounded-lg text-sm">
            <p><strong>{payment.last_name} {payment.first_name}</strong></p>
            <p className="text-[#22c55e] font-semibold">{payment.price_eur?.toLocaleString("fr-BE", { minimumFractionDigits: 2 })} €</p>
            <p className="text-[#8fa4b5]">{payment.nature}</p>
          </div>
        )}
        <p className="mt-4 text-sm text-red-500">Cette action est irréversible.</p>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
        <Button variant="destructive" onClick={onConfirm} disabled={loading}>{loading ? "Suppression..." : "Supprimer"}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
